import { useAppContext } from "@web/route-services/root/AppContext";
import { Route } from "@web/routes";

/**
 * Returns the NSFW status based on both user preferences and the search params.
 * Non signed in users can't persist their preferences to the database, so we must use the search params in such cases.
 */
export function useComputedNSFW() {
  const { nsfwOK = false } = Route.useSearch();
  const { settings } = useAppContext();
  return settings?.nsfwOK || nsfwOK;
}
